<template>
  <admin-wrapper :straight-title="additionalModuleName" :moduleEnabler="moduleEnabler" :hasButtons="false">
    <template #postForm>
      <admin-tabs-layers
        scope="masterplan_illumination"
        class="pt-8"
        schema_scope="masterplan_illumination"
        :tab-prop="tab"
      />
    </template>
  </admin-wrapper>
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'MasterplanIlluminationSettings',
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    additionalModuleName: get('admin/additionalModules.MASTERPLAN_ILLUMINATION.verbose_name'),
    moduleEnabler() {
      return {
        name: 'masterplan_illumination_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
